import { render, staticRenderFns } from "./UserTextCorrections.vue?vue&type=template&id=df5d7a9e&scoped=true&"
import script from "./UserTextCorrections.vue?vue&type=script&lang=js&"
export * from "./UserTextCorrections.vue?vue&type=script&lang=js&"
import style0 from "./UserTextCorrections.vue?vue&type=style&index=0&id=df5d7a9e&prod&lang=scss&"
import style1 from "./UserTextCorrections.vue?vue&type=style&index=1&id=df5d7a9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5d7a9e",
  null
  
)

export default component.exports